import { Position } from "../models";

export class Transforms {
  private static readonly positionMap: Record<Position, string> = {
    [Position.Left]: "left",
    [Position.Right]: "right",
    [Position.Top]: "top",
  };

  private static readonly validPositionStrings: string[] = Object.values(
    Transforms.positionMap,
  );

  public static toPosition(value: string | Position): string {
    if (typeof value === "string") {
      const lowercased = value.toLowerCase();
      return Transforms.validPositionStrings.includes(lowercased)
        ? lowercased
        : "left";
    }
    return Transforms.positionMap[value] || "left";
  }
}
